<header class="maintenance-header">
  <div class="sdps-grid-container sdps-wrap">
    <div class="col-content">
      <div class="col-1 t-logo">
        <img src="assets/img/schwab-logo.png" [alt]="shellConstant.maintenance.logoAlt">
      </div>
      <span class="header-text">
        <strong>{{ shellConstant.maintenance.headerTitle }}<sup>TM</sup></strong>
      </span>
    </div>
  </div>
</header>

<main class="main-header">
  <div class="Maintenance-Page">
    <div class="heading-tags sdps-font-weight-bold sdps-m-top_xx-large">
      <span class="tech-issue-content">{{ shellConstant.maintenance.heading }}</span>
    </div>

    <div class="col-3 m-logo">
      <span class="sch sch-tools-2x maintenance-icon" aria-hidden="true"></span>
    </div>

    <div class="sub-content">
      <span class="mean-time-header sdps-font-weight-bold">{{ shellConstant.maintenance.meantimeHeader }}</span>
      <div class="phone">
        <span><em class="pi pi-clock"></em></span>
        <span class="footer-content">{{ shellConstant.maintenance.tryAgain }}</span>
      </div>
      <div class="phone sdps-m-bottom_xx-large">
        <span><em class="sch-phone"></em></span>
        <span class="footer-content">
          Contact Designated Brokerage<br>Services Support at<br>
          <a [href]="'mailto:' + shellConstant.maintenance.supportEmail">{{ shellConstant.maintenance.supportEmail }}</a><br>
          or call {{ shellConstant.maintenance.supportPhone }}.
        </span>
      </div>
    </div>
  </div>
</main>

<footer class="maintenance-footer">
  <div class="sdps-grid-container sdps-wrap">
    <div class="col-10 sdps-m-bottom_medium">
      <strong>{{ shellConstant.maintenance.footerHelp }}</strong>
    </div>
    <div class="col-12 sdps-m-bottom_medium">
      {{ shellConstant.maintenance.footerDisclosure }}
    </div>
    <div class="col-8">
      &copy; {{ year | date : 'yyyy' }} {{ shellConstant.maintenance.footerCopyright }}
    </div>
  </div>
</footer>
